<template>
    <div class="row justify-content-center">
        <div class="col-12">
            <p class="text-small text-primary mb-2 font-weight-bold">{{trans('courses.multicircle_exercise.step_2')}}</p>
            <h4 class="text-primary mb-4">{{trans(('courses.multicircle_exercise.characteristics_start_title'))}}</h4>
        </div>

        <div class="col-12">
            <p>{{trans('courses.multicircle_exercise.characteristics_start_description')}}</p>
        </div>

        <div class="col-9 text-center my-4">
            <b-img src="/images/multicircle/characteristics-start.png" fluid/>
        </div>

        <div class="col-12 mt-2 d-flex justify-content-end">
            <b-button variant="secondary" @click="$emit('next')">
                {{trans('courses.multicircle_exercise.next')}}
            </b-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CharacteristicsStart"
    }
</script>